import React from "react";

// Shared status metadata for process-server onboarding documents & account state.
export const DOC_STATUS_META = {
  missing: { label: "Missing", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  submitted: { label: "Submitted", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  pending_approval: { label: "Pending Approval", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  approved: { label: "Approved", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rejected: { label: "Rejected", cls: "bg-red-50 text-red-700 border-red-200" },
};

export const SERVER_STATUS_META = {
  active: { label: "Approved", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  pending_approval: { label: "Pending Approval", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  rejected: { label: "Rejected", cls: "bg-red-50 text-red-700 border-red-200" },
};

export function DocStatusBadge({ status, testid }) {
  const m = DOC_STATUS_META[status] || DOC_STATUS_META.missing;
  return (
    <span data-testid={testid} className={`inline-block rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${m.cls}`}>
      {m.label}
    </span>
  );
}

export function ServerStatusBadge({ status, testid }) {
  const m = SERVER_STATUS_META[status] || SERVER_STATUS_META.active;
  return (
    <span data-testid={testid} className={`inline-block rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${m.cls}`}>
      {m.label}
    </span>
  );
}
